const organization = [
  { name: 'NGO', value: 23 },
  { name: 'LSM', value: 12 },
  { name: 'Donor', value: 5 },
  { name: 'School', value: 5 },
  { name: 'Government', value: 3 },
  { name: 'Corporate', value: 2 },
]

const organizationFiltered = [
  { name: 'NGO', value: 4 },
  { name: 'LSM', value: 3 },
  { name: 'Donor', value: 0 },
  { name: 'School', value: 0 },
  { name: 'Government', value: 0 },
  { name: 'Corporate', value: 0 },
]

const approach = [
  { name: 'Pencegahan', value: 23 },
  { name: 'Reintegrasi', value: 12 },
  { name: 'Rehabilitasi', value: 5 },
  { name: 'Kontra Narasi', value: 5 },
  { name: 'Penguatan', value: 3 },
  { name: 'Kemitraan', value: 2 },
]

const approachFiltered = [
  { name: 'Pencegahan', value: 75 },
  { name: 'Reintegrasi', value: 25 },
  { name: 'Rehabilitasi', value: 0 },
  { name: 'Kontra Narasi', value: 0 },
  { name: 'Penguatan', value: 0 },
  { name: 'Kemitraan', value: 0 },
]

const issues = [
  { name: 'Pemuda', value: 23 },
  { name: 'Perempuan', value: 12 },
  { name: 'Tokoh Agama', value: 5 },
  { name: 'Pelajar', value: 5 },
  { name: 'Universitas', value: 3 },
  { name: 'Korban', value: 2 },
  { name: 'Returnee', value: 2 },
  { name: 'Eks-anggota', value: 2 },
]

const issuesFiltered = [
  { name: 'Pemuda', value: 100 },
  { name: 'Perempuan', value: 0 },
  { name: 'Tokoh Agama', value: 0 },
  { name: 'Pelajar', value: 0 },
  { name: 'Universitas', value: 0 },
  { name: 'Korban', value: 0 },
  { name: 'Returnee', value: 0 },
  { name: 'Eks-anggota', value: 0 },
]

const location = [
  { name: 'Jakarta', value: 40 },
  { name: 'Bandung', value: 32 },
  { name: 'Surabaya', value: 23 },
  { name: 'Yogyakarta', value: 22 },
  { name: 'Semarang', value: 11 },
  { name: 'Garut', value: 11 },
  { name: 'Aceh', value: 3 },
  { name: 'Batam', value: 1 },
  { name: 'Palu', value: 40 },
  { name: 'Bali', value: 32 },
  { name: 'Depok', value: 23 },
  { name: 'Bekasi', value: 22 },
  { name: 'Palembang', value: 11 },
  { name: 'Banjarmasin', value: 11 },
  { name: 'Padang', value: 3 },
]

const locationFiltered = [
  { name: 'Jakarta', value: 40 },
  { name: 'Bandung', value: 32 },
  { name: 'Tasikmalaya', value: 23 },
  { name: 'Depok', value: 22 },
  { name: 'Bogor', value: 11 },
  { name: 'Kuningan', value: 11 },
]

const data = {
  organization: {
    data: organization,
    total: getTotal(organization)
  },
  organizationFiltered: {
    data: organizationFiltered,
    total: getTotal(organizationFiltered)
  },
  approach: {
    data: approach,
    total: getTotal(approach)
  },
  approachFiltered: {
    data: approachFiltered,
    total: getTotal(approachFiltered)
  },
  issues: {
    data: issues,
    total: getTotal(issues)
  },
  issuesFiltered: {
    data: issuesFiltered,
    total: getTotal(issuesFiltered)
  },
  location: {
    data: location,
    total: getTotal(location)
  },
  locationFiltered: {
    data: locationFiltered,
    total: getTotal(locationFiltered)
  }
}

function getTotal(data) {
  return data.map(d => d.value).reduce((a, b) => a + b)
}

export default data